exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".\\--requiredVariant[data-v-53624236] {\n  color: red;\n}", ""]);

// exports
